export default function getMeasureMappings(): any {
  const measureMappings: any = {};
  measureMappings.HK521 = [
    {name: 'HK521//HK521.LIA01_X', quality: 'cm', active: false, description: 'Venttiilikaivo 68 pinnanmittaus'},
    {
      name: 'HK521//HK521.QTI02_X',
      quality: 'mg/l',
      active: false,
      description: 'Venttiilikaivo 68 Glykolipit. mittaus(TOC/ Laitetilan analysaattori)'
    },
    {
      name: 'HK521//HK521_FIQ01_X',
      quality: 'm3/h',
      active: false,
      description: 'Kaivo67 ylivuotovirtausmittaus (laskettu mittapadon avulla)'
    },
    {
      name: 'HK521//HK521_FIQ02_2',
      quality: 'm3/h',
      active: false,
      description: 'Kaivo82 ylivuotovirtausmittaus (laskettu mittapadon avulla)'
    },
    {name: 'HK521_LIA02_X', quality: 'cm', active: false, description: 'Venttiilikaivo 81 pinnanmittaus'}
  ];
  return measureMappings;

}
